import apiPaths from '../api-paths';

export default {
  show({ id }) {
    return axios.get(`${ apiPaths.CRM }/partner-crms/${ id }`);
  },
  store({ data }) {
    return axios.post(`${ apiPaths.CRM }/partner-crms`, { partnercrm: data });
  },
  update({ data }) {
    return axios.put(`${ apiPaths.CRM }/partner-crms/${ data.id }`, { partnercrm: data });
  },
  preliminaryValidation({ data }) {
    return axios.post(`${ apiPaths.CRM }/partner-crms/preliminary-validation`, { partnercrm: data });
  },
  listCrmsForPartnerCrm() {
    return axios.get(`${ apiPaths.CRM }/partner-crms/crms`);
  },
  changeApprovalRequestStatus({ approvalRequest }) {
    return axios.put(`${ apiPaths.CRM }/partner-crms/approval-requests/${ approvalRequest.id }`, { partnercrmapprovalrequest: approvalRequest });
  },
  listByCrmOriginal({ crmOriginal }) {
    return axios.get(`${ apiPaths.CRM }/partner-crms/by-crm-original/${ crmOriginal }`);
  },
  downstream: {
    indexRepresentatives({ query }) {
      return axios.get(`${ apiPaths.DOWNSTREAM.CRM }/partner-crms/representatives${ query }`);
    },
    syncRepresentatives({ representatives, crmOriginal }) {
      return axios.post(`${ apiPaths.DOWNSTREAM.CRM }/partner-crms/representatives`, { crmOriginal, representatives });
    },
    index({ query }) {
      return axios.get(`${ apiPaths.DOWNSTREAM.CRM }/partner-crms${ query }`);
    },
    store({ data, crmOriginal }) {
      return axios.post(`${ apiPaths.DOWNSTREAM.CRM }/partner-crms`, { partnercrm: data, crmOriginal });
    },
    update({ data, crmOriginal }) {
      return axios.put(`${ apiPaths.DOWNSTREAM.CRM }/partner-crms/${ data.id }`, { partnercrm: data, crmOriginal });
    },
    destroy({ id, query }) {
      return axios.delete(`${ apiPaths.DOWNSTREAM.CRM }/partner-crms/${ id }${ query }`);
    },
  },
};
